import React, { useContext, useEffect, useState } from "react";
import { getNodeCapability } from "../../handler/ParentDataHandler";
import { CapabilityContext } from "../../overview/context/CapabilityContext";
import { isSSD } from "../../outboundSSD/util/Util";
import AmzlSettingsSkeleton from "./AmzlSettingsSkeleton";
import SsdSettingsSkeleton from "./ssd/SsdSettingsSkeleton";

const SettingsSkeleton = () => {
  const [isLoadingNodeCapability, setIsLoadingNodeCapability] = useState(true);
  const { capability, dispatch: capabilityDispatch } =
    useContext(CapabilityContext);

  useEffect(() => {
    const asyncFunc = async () => {
      await getNodeCapability().then((capabilities) => {
        capabilityDispatch({ type: "GET_CAPABILITIES", capabilities });
      });
      setIsLoadingNodeCapability(false);
    };
    asyncFunc();
  }, []);

  return isLoadingNodeCapability ? (
    <div />
  ) : capability && isSSD(capability.data) ? (
    <SsdSettingsSkeleton />
  ) : (
    <AmzlSettingsSkeleton />
  );
};

export default SettingsSkeleton;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsSkeleton.js